<template>
  <slot
    :refurbishedclick="addRefurbishedProductToCart"
    :loading="isLoading"
    :disabled="disabled"
  />
  <product-confirmation-modal />
</template>
<script setup>
import {
  ref, provide, computed,
} from 'vue';
import { useQueryClient } from '@tanstack/vue-query';
import useProduct from '../../uses/useProduct';
import ProductConfirmationModal from './ProductConfirmationModal.vue';
import useAddToCart from '../../features/cart/composable/useAddToCart';
import useCartQuery from '../../features/cart/api/useCartQuery';

const queryClient = useQueryClient();
const {
  quantity,
} = useProduct();
const { addToCart, isLoading: isAddingToCart, addToCartTag } = useAddToCart();
const { data: cartData, isLoading: isCartLoading } = useCartQuery();
const props = defineProps({
  refurbished: {
    type: Object,
    required: true,
  },
  product: {
    type: Object,
    required: true,
  },
  prices: {
    type: Object,
    required: true,
  },
});

const modal = ref({
  open: false,
  payload: null,
});

const isLoading = computed(() => isAddingToCart.value || isCartLoading.value);

const isAlreadyInCart = computed(() => cartData.value?.data?.cart?.items.find(
  (item) => item.product.id === props.refurbished.id,
));

const disabled = computed(() => isAlreadyInCart.value || isLoading.value);

const addRefurbishedProductToCart = function () {
  addToCart(props.refurbished.id, quantity.value, {
    onSuccess: () => {
      addToCartTag(props.product, quantity.value, props.prices, props.refurbished);
      modal.value.open = true;
      queryClient.invalidateQueries({ queryKey: ['cart'], exact: true });
      queryClient.invalidateQueries({ queryKey: ['user'], exact: true });
    },
  });
};

provide('modal', modal);
</script>
